import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const accordionContent = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      &:not([data-open]) {
        display: block;
      }
    `,
  )};

  &[data-open='false'] {
    display: none;
  }
  &[data-open='true'] {
    display: block;
  }
`;

export const toggleButton = css`
  background: none;
  color: inherit;
  border: none;
  font: inherit;
  padding: 0;

  > span {
    display: inline-block;
    visibility: hidden;

    > span {
      width: 16px;
      height: 16px;
    }
  }

  &[aria-expanded] > span {
    visibility: visible;
  }
`;

export const copyBlockContent = css`
  overflow: auto;
  display: flex;
  justify-content: left;
  margin: ${spacing.md}px 0 0;

  a {
    color: var(--brand-purple-base);
  }
  p {
    margin: 0;
    color: var(--neutral-black-base);
  }
`;

export const headerCopyBlock = css`
  text-align: left;
  margin-bottom: ${spacing.md}px;
`;

export const heading = css`
  display: inline-block;
  margin: 0;
  color: var(--neutral-black-base);
  ${responsiveText.HEADING.XL};
  font-weight: normal;
`;

export const subheading = css`
  ${responsiveText.HEADING.SM};
  font-weight: 600;
  margin: ${spacing.md}px 0;
`;

const chevron = css`
  display: inline-block;
  border-left: 1px solid var(--neutral-black-base);
  border-top: 1px solid var(--neutral-black-base);
`;

export const icon = css`
  width: ${spacing.sm}px;
  height: ${spacing.sm}px;
  margin-left: ${spacing.sm}px;

  &:not([data-open]) {
    visibility: hidden;
  }

  &[data-open='false'] {
    ${chevron};
    transform: rotate(225deg);
    vertical-align: super;
  }

  &[data-open='true'] {
    ${chevron};
    transform: rotate(45deg);
    vertical-align: middle;
  }
`;
